import AppData from '../../Model/MerchantAppData';
import BaseFirebaseRepository from './BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class AppSettingRepository extends BaseFirebaseRepository {
    /**
     * @param {*} app 
     * @return {AppSettingRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = AppData.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new AppSettingRepository(app)
        }
        return instances[app]
    }
    constructor(app) {
        super(app)
    }
    getRef = () => {
        return firebase.database().ref(firebase_path + '/app_settings/')
            .orderByChild("is_public")
            .equalTo(1)
    }
    getBaseObject = () => {
        return {}
    }
}